<template>
  <div style="display: inline-block">
    <el-popover
      v-if="studentState.studentStateDesc"
      placement="bottom"
      title="提示"
      width="600"
      trigger="click">
      <div v-html="decodeURIComponent(studentState.studentStateDesc)"></div>
      <el-tag
      slot="reference"
      v-if=" studentState.studentState == 1||studentState.studentState == 3"
      class="student_tag_yellow"
      >{{ studentState.studentStateStr }}</el-tag
    >
    <el-tag
    slot="reference"
      v-else-if="studentState.studentState == 7 "
      class="student_tag_green"
      >{{ studentState.studentStateStr }}</el-tag
    >
    <el-tag
    slot="reference"
      v-else-if="
        studentState.studentState == 8|| studentState.studentState == 6
      "
      class="student_tag_red"
      >{{ studentState.studentStateStr }}</el-tag
    >
    <el-tag
    slot="reference"
      v-else-if="studentState.studentState == 2  || studentState.studentState == 4"
      class="student_tag_blue"
      >{{ studentState.studentStateStr }}</el-tag
    >
    <el-tag v-else slot="reference" class="student_tag_gray">{{
      studentState.studentStateStr
    }}</el-tag>
    </el-popover>
    <div v-else>
      <el-tag
      v-if=" studentState.studentState == 1||studentState.studentState == 3"
      class="student_tag_yellow"
      >{{ studentState.studentStateStr }}</el-tag>
        <el-tag v-else-if="studentState.studentState == 7 "
        class="student_tag_green"
        >{{ studentState.studentStateStr }}</el-tag>
      <el-tag
        v-else-if="
          studentState.studentState == 8|| studentState.studentState == 6"
        class="student_tag_red"
        >{{ studentState.studentStateStr }}</el-tag
      >
      <el-tag
        v-else-if="studentState.studentState == 2  || studentState.studentState == 4"
        class="student_tag_blue"
        >{{ studentState.studentStateStr }}</el-tag
      >
      <el-tag v-else class="student_tag_gray">{{
        studentState.studentStateStr
      }}</el-tag>
    </div>

  </div>
</template>

<script>
export default {
  name: "studentStateTagColor",
  props: {
    //接收父组件参数
    studentState: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {},
  data() {
    return {};
  },
  created() {
  },
};
</script>

<style>
</style>